'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { i18n } from 'react-i18n'
import * as FPT from '../utility/fpt'
import TemplateData from '../utility/getTemplateData'

let PropTypes = React.PropTypes

export default React.createClass({

    mixins: [i18n('common/cancelAndReturn')],

    propTypes:{},

    getInitialState () {
        return {
            displayMe : (TemplateData.charityCancelUrl) ? true : false
        };
    },

    handleCancel (){

        FPT.trackLinkClick('cancel');

        let cancelurl = TemplateData.charityCancelUrl;
        window.location.href = cancelurl;
    },

    render () {

        let labelreturn = this.i18n('label.return')

        labelreturn = labelreturn.replace('{orgName}', TemplateData.donationName);

        return (
            <div>
                {this.state.displayMe ?
                    <div className="col-xs-12 col-sm-12 col-md-12 text-center pp_cancel_btn_wrapper">
                        <a className="btn btn-primary pp_cancel_btn" id="cancelReturnBtn" onClick={this.handleCancel}
                            dangerouslySetInnerHTML={{__html : labelreturn}}></a>
                    </div> : null
                }
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./common/cancelAndReturn.js
 **/